<template>
    <div class="modal" :class="{'is-active':isActiveObjectModal}">
        <div @click="$emit('closeObjectModal')" class="modal-background"></div>
        <div class="modal-card  animate__animated animate__zoomIn animate__faster" style="width: 70%;height: 90%">
            <header class="modal-card-head">
                <p class="modal-card-title"></p>
                <button class="delete is-large" @click="$emit('closeObjectModal')" aria-label="close">
<!--                    <font-awesome-icon icon="delete"/>-->
                </button>
            </header>
            <section class="modal-card-body">
                <div v-if=" object.length === 1 " class="object-render-table has-text-centered" style="width: 70%; ">
                    <table class="table is-hoverable is-fullwidth is-narrow is-striped is-bordered is-center">
                        <thead>
                        <th width="250">Name</th>
                        <th>Value</th>
                        </thead>
                        <tbody>
                        <tr v-for="(value,name) in object[0]" :key="name">
                            <td>{{name | nameReplaceUpperSpace}}</td>
                            <td>{{value}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="object-render-table">
                    <table class="table is-hoverable is-fullwidth is-narrow is-striped is-bordered">
                        <thead>
                        <tr>
                            <th v-for="(value,name) in object[0]" :key="name">{{name | nameReplaceUpperSpace}}</th>
                        </tr>
                        </thead>
                        <tbody v-if="object.length">
                        <tr v-for="item in object.length" :key="item">
                            <td v-for="(value,name) in object[item]" :key="name">{{value}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            <footer class="modal-card-foot">

            </footer>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ObjectRendering",
        data() {
            return {}
        },
        props: ['isActiveObjectModal', 'object', 'objectLenght'],
        created() {
        },
        mounted()
        {
            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27) { //ESC
                    this.$emit('closeObjectModal');
                }
            })
        },
        methods:
        {




        }

    }
</script>

<style scoped>
    .object-render-table thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 17px;
        top: -12px;
        position: sticky;
        z-index: 2;
    }

    .object-render-table td {
        border: 0px;
    }

    .object-render-table {
        overflow-y: scroll;
        height: 100%;
        width: 100%;
        position: center;
        display: block;
    }

    .object-render-table th {
        top: -12px;
        position: sticky;
        background-color: white;
        z-index: 2;
    }

</style>
